import { PayloadAction } from 'typesafe-actions';
import { RecurringOrdersContextActionTypes, RecurringOrdersState } from './types';

const RecurringOrdersReducer = (
  state: RecurringOrdersState,
  action: PayloadAction<RecurringOrdersContextActionTypes, any>,
): RecurringOrdersState => {
  switch (action.type) {
    case RecurringOrdersContextActionTypes.SetSelectedRecurringOrdersTab:
      return {
        ...state,
        selectedRecurringOrdersTab: action.payload,
      };

    case RecurringOrdersContextActionTypes.SetSelectedRecurringOrder:
      return {
        ...state,
        selectedRecurringOrder: action.payload.selectedRecurringOrder,
        recurringOrderAction: action.payload.action,
      };

    case RecurringOrdersContextActionTypes.ResetSelectedRecurringOder:
      return {
        ...state,
        selectedRecurringOrder: action.payload,
        recurringOrderAction: action.payload,
        recurringOrderSubmitAction: action.payload,
        cancelRecurringOrderData: action.payload,
        viewRecurringOrderDetailsData: action.payload,
      };

    case RecurringOrdersContextActionTypes.SetRecurringOrderSubmitAction:
      return {
        ...state,
        recurringOrderSubmitAction: action.payload,
      };

    default: {
      return state;
    }
  }
};

export { RecurringOrdersReducer };
